import { FC } from "react"
import { AnunciosI } from "../../models/home"
import useAnuncios from "./useAnuncios"
import { Backdrop, CircularProgress, Typography } from "@mui/material"
import MultipleAnunciosDropzone from "./MultipleAnuncios"

interface Props {
}

const Anuncios: FC<Props> = ({ }) => {

  const {
    formData,
    setFormData,
    onSubmitForm,
    removeAnuncio,
    isLoading,
    isSubmitting,
  } = useAnuncios()

  return (
    <>
      <Backdrop
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
        open={isSubmitting}
      >
        <CircularProgress size={60} color="inherit" />
        <Typography variant="h6">
          Guardando cambios...
        </Typography>
      </Backdrop>

      <form onSubmit={onSubmitForm} style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        marginTop: '50px',
      }}>
        <h1>ANUNCIOS</h1>

        <div style={{
          background: 'white'
        }} className="contenedor">

          <h2 className="titSeccion">Anuncios</h2>

          <MultipleAnunciosDropzone
            anuncios={formData || []}
            setAnuncios={(anuncios: AnunciosI) => {
              console.log(anuncios)
              setFormData(anuncios)
            }}
            title='Anuncios'
            onRemove={removeAnuncio}
          />

        </div>

        {isLoading && <div>Cargando Espere...</div>}

        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', }}>
          <input type="reset" value="Cancelar" className="btnCancelar" disabled={isLoading} />
          <input type="submit" value="Aceptar" className="btnAceptar" disabled={isLoading} />
        </div>
      </form>
    </>
  )
}

export default Anuncios
